<template>
  <div class="mains">
    <div class="campus">
      教材管理
      <span>></span>学校教材区
    </div>
    <div class="xiaoqu moerduo">
      <el-row :gutter="24">
        <el-col :span="24">
          <div class="grid-content bg-purple scrollbarStyle" style="height: 85vh; overflow: auto">
            <el-dialog title="新建文件夹" :visible.sync="addBookGroups">
              <div class="form_1 form_1_1">
                <el-form ref="forms" :model="forms" :rules="FormRules" label-width="5.20833vw">
                  <el-form-item label="文件夹名称" prop="name" class="wjj_mc">
                    <i>
                      <img src="@/assets/img/education-manage/campus/bitian.png" style="left: -5vw; top: 0.78125vw" class="wuzi" />
                    </i>
                    <el-input v-model="forms.name" placeholder="请输入文件夹名称"></el-input>
                  </el-form-item>
                  <el-form-item class="queding">
                    <el-button type="primary" @click="addBookGroup">
                      确定
                    </el-button>
                    <el-button @click="quxiao">取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>

            <el-dialog title="添加教材" :visible.sync="getBookLists" class="tj_jc">
              <div class="form_1 form_1_1">
                <el-form ref="forms" :model="forms" :rules="FormRules" label-width="5.20833vw">
                  <el-form-item label prop="name" class="wjj_mc quanbu_jc">
                    <div>
                      <div class="jc_fl">教材分类</div>
                      <div class="jc_11">教材</div>
                      <div class="sousuo sousuo_wjj jc_ss">
                        <span>教材名称：</span>
                        <el-input v-model="orgnamess" @keyup.13.native="getBookList" placeholder="请输入教材关键字进行查找"></el-input>
                        <el-button type="primary" class="buttons sousuo_wjj1" @click="getBookList()">查 询</el-button>
                      </div>
                    </div>
                    <div class="jc_22">
                      <div class="quanbujiaocai">
                        <div :class="{ quanbujiaocai_2: index == selectTypeIndex }" v-for="(item, index) in jiaocai_List" :key="index" @click="jiaocai_List_1(index)">
                          {{ item }}
                        </div>
                      </div>

                      <div class="jiaocai_1 jiaocai_1s jiao_tu">
                        <div class="jiaocai" v-for="(item, index) in jiaoyu1" :key="index">
                          <div class="jiaocai_tu">
                            <el-checkbox class="is-checked0" @change="xuanzhong(item)">
                              <img :src="item.zuoshangjiao" class="zuoshangjiao" />
                              <img :src="item.picurl" style="border-radius: 0.52083vw" @click="ddxz(item)" />
                              <img :src="item.youxiajiao" style="float: right" class="youxiajiao" :class="item.youxiajiao ? '' : 'youxiajiao2'" />
                            </el-checkbox>
                          </div>
                          <div class="jiaocai_zi">{{ item.name }}</div>
                        </div>

                        <div class="jiaocai_zong">
                          共<span> {{ totals }} </span>
                          本教材，当前页面显示<span> {{ jczongshu0 }} </span>本
                        </div>
                        <el-pagination class="fenye_1" background @size-change="handleSizeChanges" @current-change="handleCurrentChanges" :current-page="currentPages" :page-size="pageSizes"
                          layout="prev, pager, next, jumper" :total="totals">
                        </el-pagination>
                      </div>
                    </div>
                  </el-form-item>

                  <el-form-item class="queding jiaocai_queding">
                    <el-button type="primary" @click="addToSchoolUsingBook">
                      确定
                    </el-button>
                    <el-button @click="quxiao">取消</el-button>
                  </el-form-item>
                </el-form>
              </div>
            </el-dialog>

            <div class="xiaoqu_1">学校教材区</div>
            <el-button type="primary" class="buttons xj_wjj" @click="getBookList1">
              <span>+</span>
              添加教材
            </el-button>
            <!--
            <el-button
              type="primary"
              style="width: 5.72917vw"
              class="buttons xj_wjj"
              @click="addBookGroup1"
            >
              <span>+</span>
              新建文件夹
            </el-button>
            -->
            <div class="sousuo sousuo_wjj">
              <span>教材名称：</span>
              <el-input v-model="orgnames" @keyup.13.native="getBookGoupList" placeholder="请输入教材关键字进行查找"></el-input>
              <el-button type="primary" class="buttons sousuo_wjj1" @click="getBookGoupList()">
                查 询
              </el-button>
            </div>
            <div class="zsbg_1 jiaocai_1 jiaocai_1s dz-flex dz-flex-wrap">
              <div class="jiaocai " v-for="(item, index) in jiaoyu" :key="index">
                <div class="jiaocai_tu">
                  <img :src="item.zuoshangjiao" class="zuoshangjiao" alt="" />
                  <span class="yinying">
                    <span class="yinying_zi">{{ item.name }}</span>
                    <img :src="item.picurl" style="border-radius: 0.52083vw" />
                  </span>
                  <img :src="item.youxiajiao" style="float: right" class="youxiajiao" :class="item.youxiajiao ? '' : 'youxiajiao2'" />
                </div>
                <div class="jiaocai_zi">{{ item.name }}</div>
              </div>
            </div>
            <div class="function_zong ml-30 mt-20">
              共<span> {{ total }} </span>本教材，当前页面显示
              <span> {{ jczongshu1 }} </span>本
            </div>
            <el-pagination class="fenye_1" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'schoolbook',
  data() {
    return {
      jiaocai_List: ['全部教材', '官方教材', '自制教材'],
      selectTypeIndex: 1,
      type: 0,
      orgnames: '',
      orgnamess: '',
      jiaoyu: [],
      jiaoyu1: [],
      xz_jc: [],
      FormRules: {},
      xz_jc1: '',
      page: 1,
      pageSize: 24,
      pageSizes: 10,
      currentPage: 1,
      currentPages: 1,
      total: 0,
      totals: 0,
      forms: {
        name: '',
      },
      checkedNames: [],
      quanbujiaocai_s: true,
      addBookGroups: false,
      getBookLists: false,
      jczongshu0: '',
      jczongshu1: '',
    };
  },
  watch: {
    addBookGroups() {
      if (this.addBookGroups === false) {
        this.forms.name = '';
      }
    },
  },
  created() {
    this.getBookGoupList();
  },
  methods: {
    // 添加文件夹
    addBookGroup1() {
      this.addBookGroups = true;
    },
    addBookGroup() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/bookgroup/addBookGroup',
        method: 'POST',
        data: {
          name: this.forms.name,
          orgid: orgid,
          picurl: 'http://',
          type: 0,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          if (this.forms.name === '') {
            return this.$message.error('请先输入文件夹名称！');
          } else {
            this.addBookGroups = false;
            this.getBookGoupList();
            return this.$message.success('新建文件夹完成!');
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('新建文件夹失败：' + err);
        });
    },
    quxiao() {
      if (this.addBookGroups) {
        this.addBookGroups = false;
      }
      if (this.getBookLists) {
        this.getBookLists = false;
      }
    },

    // 添加教材
    jiaocai_List_1(index) {
      // console.log(index)
      this.selectTypeIndex = index;
      if (index === 0) {
        this.type = '';
        this.getBookList();
      } else if (index === 1) {
        this.type = 0;
        this.getBookList();
      } else if (index === 2) {
        this.type = 1;
        this.getBookList();
      }
    },
    getBookList1() {
      this.getBookLists = true;
      this.getBookList();
    },
    getBookList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/getBookList',
        method: 'POST',
        data: {
          orgid: orgid,
          type: this.type,
          name: this.orgnamess,
          page: this.pages,
          pageSize: this.pageSizes,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.jiaoyu1 = result.data.data;
          this.jczongshu0 = result.data.data.length;
          this.jiaoyu1.forEach(function (c) {
            if (c.type === 0) {
              c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/guanfang.png');
              c.youxiajiao = require('@/assets/img/textbook-manage/schoolbook/diandu.png');
            }
            if (c.type === 1) {
              c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/zizhi1.png');
              c.youxiajiao = require('@/assets/img/textbook-manage/schoolbook/zizhi.png');
            }
            c.selected = false;
          });
          if (this.jiaoyu1 === undefined || this.jiaoyu1 === null) {
            this.totals = 0;
          } else {
            this.totals = result.data.size;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询添加教材失败：' + err);
        });
    },

    ddxz(index) {
      // this.xuanzhong(index)
    },

    xuanzhong(index) {
      console.log(index.selected);
      index.selected = !index.selected;
      if (index.selected === true) {
        this.xz_jc.push(index.id);
      } else if (index.selected === false) {
        this.xz_jc.splice(this.xz_jc.indexOf(index.id), 1);
      }
      console.log(index.selected);
      console.log(this.xz_jc);
    },
    addToSchoolUsingBook() {
      this.xz_jc1 = this.xz_jc.join('&#');
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/book/addToSchoolUsingBook',
        method: 'POST',
        data: {
          orgid: orgid,
          ids: this.xz_jc1,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.getBookLists = false;
          this.getBookGoupList();
          this.xz_jc = [];
          return this.$message.success('添加教材完成!');
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('添加教材失败：' + err);
        });
    },

    // 查询教材
    getBookGoupList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let orgid = window.sessionStorage.getItem('orgid');
      let pro = this.$http({
        url: '/edu/bookgroup/getBookGoupList',
        method: 'POST',
        data: {
          orgid: orgid,
          name: this.orgnames,
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result.data)
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          this.jiaoyu = result.data.data;
          this.jczongshu1 = result.data.data.length;
          this.jiaoyu.forEach(function (c) {
            if (c.type === 5) {
              c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/wenjianjia.png');
              c.youxiajiao = false;
            }
            if (c.type === 0) {
              c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/guanfang.png');
              c.youxiajiao = require('@/assets/img/textbook-manage/schoolbook/diandu.png');
            }
            if (c.type === 1) {
              c.zuoshangjiao = require('@/assets/img/textbook-manage/schoolbook/zizhi1.png');
              c.youxiajiao = require('@/assets/img/textbook-manage/schoolbook/zizhi.png');
            }
          });
          if (this.jiaoyu === undefined || this.jiaoyu === null) {
            this.total = 0;
          } else {
            this.total = result.data.size;
          }
        })
        .catch((err) => {
          // console.log(err)
          return this.$message.error('查询教材失败：' + err);
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.currentPage = 1;
      this.getBookGoupList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getBookGoupList();
    },
    handleSizeChanges(val) {
      this.pageSizes = val;
      this.pages = 1;
      this.currentPages = 1;
      this.getBookList();
    },
    handleCurrentChanges(val) {
      this.pages = val;
      this.getBookList();
    },
  },
};
</script>

<style lang="less">
.clear {
  clear: both;
}
.el-pagination__editor.el-input .el-input__inner {
  width: 25px !important;
}
.mains .xiaoqu .grid-content .tj_jc {
  .quanbu_jc {
    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  .el-dialog {
    width: 1300px !important;
    height: 850px;
    top: 50%;
  }
  .el-dialog__header {
    width: 1240px !important;
    .el-dialog__title {
      font-size: 22px;
      padding-left: 28px;
    }
    .el-dialog__title:before {
      height: 22px;
      top: 26px;
      left: 40px;
    }
    .el-dialog__headerbtn {
      right: 40px;
    }
  }
  .jc_11 {
    float: left;
    margin-left: 185px;
    font-size: 18px;
  }
  .jc_fl {
    float: left;
    font-size: 20px;
    color: #333;
    font-weight: bold;
    margin-left: 28px;
  }
  .jc_ss {
    margin: 0;
    .el-input {
      input {
        width: 220px;
      }
    }
  }

  .jc_22 {
    clear: both;
    margin-left: -10px;
    .quanbujiaocai {
      margin-top: 15px;
      float: left;
      div {
        width: 212px;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
        color: #999;
        background: #efefef;
        border-radius: 5px;
        margin: 10px 0 0 0;
        padding-left: 28px;
      }
      div:hover {
        color: #fff;
        background: #00a6e6;
      }
      .quanbujiaocai_2 {
        color: #fff;
        background: #00a6e6;
      }
    }

    .jiao_tu {
      margin-left: 260px !important;
      .jiaocai_zi {
        height: 30px;
      }
      .fenye_1 {
        margin: 0 !important;
      }
    }

    .jiaocai {
      margin: 30px 0px 0 30px !important;
      .jiaocai_tu {
        width: 162px !important;
        height: 206px !important;
        img {
          width: 150px !important;
          height: 190px !important;
          margin: 13px 0 0 -4px;
        }
        .zuoshangjiao {
          position: absolute;
          top: -8px;
          left: -5px;
          width: 50px !important;
          height: 25px !important;
          z-index: 999 !important;
        }
        .youxiajiao {
          position: absolute;
          right: -3px;
          bottom: 4px;
          width: 48px !important;
          height: 18px !important;
        }
      }
      .jiaocai_zi {
        width: 162px;
      }
      .jiaocai_tu {
        .is-checked {
          .el-checkbox__input {
            background: none !important;
          }
        }
      }
      .el-checkbox {
        position: absolute;
        // top: -14px;
        // right: -6px;
        z-index: 9999;
        .el-checkbox__input {
          width: 22px;
          height: 22px;
          float: right;
          background: url(../../../assets/img/textbook-manage/schoolbook/weixuan.png) no-repeat !important;
          background-size: 22px 22px !important;
          .el-checkbox__inner {
            width: 0;
            height: 0;
            border: none;
          }
          .el-checkbox__inner::after {
            width: 22px;
            height: 22px;
            top: -12px;
            left: 0px;
            border: none;
            background: url(../../../assets/img/textbook-manage/schoolbook/xuanzhong.png) !important;
            background-size: 22px 22px !important;
          }
          input {
            width: 0;
          }
        }
        .el-checkbox__input.is-checked .el-checkbox__inner::after {
          transform: none;
        }
      }
    }
  }
  .form_1_1 {
    .jiaocai_queding {
      margin-top: 15px;
      .el-form-item__content {
        margin-left: 216px !important;
      }
      .el-button--primary {
        width: 240px;
        height: 44px;
        border-radius: 34px;
        background: #0094ce;
        font-size: 20px;
      }
      .el-button--primary:hover {
        background: #0094ce;
      }
      .el-button--default {
        width: 240px;
        height: 44px;
        border-radius: 34px;
        background: rgba(242, 242, 242, 0.8);
        border: none;
        box-shadow: 2px 2px 6px rgba(234, 234, 234, 0.3);
      }
    }
  }
}
.youxiajiao2 {
  display: none;
}

// .jiaocai_tu:hover {
// background: #000 !important;
// opacity: 0.6;
// }
.wjj_mc {
  .el-form-item__label {
    padding: 0 !important;
    margin-left: 5px;
  }
  .el-form-item__content {
    margin-left: 140px !important;
  }
  .wuzi {
    left: -125px !important;
  }
}
</style>
